define(["dojo/_base/declare", "./ProductDefaultSize"], function (declare, ProductDefaultSize) {
	return declare(ProductDefaultSize, {
		canCopy: function (/*Context*/ ctxCopy, /*Heading*/ h) {
			// summary: can't copy from a material with owned sizes
			return ctxCopy.getNode().OwnedProductSizes.length == 0;
		},
	});
});
